import Quiz from "@components/Modules/Quiz/Quiz";
import { QuizCardProps } from "@typings/QuickNews";
import { ReactElement } from "react";

type QNQuizCardProps = {
  item?: QuizCardProps;
};

export function QnQuizCard({ item }: QNQuizCardProps): ReactElement {
  return (
    <>
      {item != undefined && (
        <div className="qn-quiz w-full h-full bg-white-100" key={item.id}>
          <Quiz mobileView={true} isQuickNews={true} />
        </div>
      )}
    </>
  );
}
